import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBAlert,
  MDBCollapse,
} from 'mdbreact'
import { toast } from 'react-toastify'
import UserProfileService from './../../../../shared/services/UserProfile.service'
import AgentTermAcceptance from './../../../../components/agents/AgentTerms/AgentTermAcceptance.component'
import SyncSubscription from './../SyncSubscription/SyncSubscription.component'
import { DowngradeModal } from './components/DowngradeModal/DowngradeModal'
import PromoCodeSubmitter from './components/PromoCodeSubmitter/PromoCodeSubmitter'
import StripeDetails from './../StripeDetails/StripeDetails.component'
import SubscriptionStatus from './../SubscriptionStatus/SubscriptionStatus.component'
import SubscriptionsStore from './../../Subscriptions.store'

import './SubscriptionPackage.scss'

const SIG_AGENT_ONE_TIME = 50,
  SIG_AGENT_RECURRING = 49.95

const SubscriptionPackage = () => {
  const [showDowngradeModal, setShowDowngradeModal] = useState(false),
    [confirmUpgradeAccount, setConfirmUpgradeAccount] = useState(false)

  const {
    isOnGrace,
    isModifying,
    subSource,
    downgradeContent,
    subscriptionId,
    paymentMethods,
    subscribeSigAgent,
    unsubscribeSigAgent,
    isNonSigAgent,
    isSigAgentVarient,
  } = SubscriptionsStore

  const renderDowngradeBtn = () => {
    return (
      <MDBBtn
        disabled={isModifying}
        className="btn-block text-center"
        onClick={() => setShowDowngradeModal(!showDowngradeModal)}
      >
        {isModifying ? (
          <>
            <span>
              <i className="fa fa-spin fa-spinner" />
            </span>
            &nbsp;<span>Canceling...</span>
          </>
        ) : (
          <>
            <span>Cancel Signature Agent Subscription</span>
          </>
        )}
      </MDBBtn>
    )
  }

  const renderUpgradeBtn = () => {
    return (
      <MDBBtn
        disabled={isModifying}
        className="btn-block text-center"
        color="indigo"
        onClick={async () => {
          if (!confirmUpgradeAccount) return setConfirmUpgradeAccount(true)

          if (await subscribeSigAgent()) {
            toast.success('Great!  Your account has been upgraded.')
            setConfirmUpgradeAccount(false)
          }
        }}
      >
        {isModifying ? (
          <>
            <span>
              <i className="fa fa-spin fa-spinner" />
            </span>
            &nbsp;<span>Upgrading...</span>
          </>
        ) : (
          <>
            <span>
              {(confirmUpgradeAccount ? 'Accept & Confirm ' : '') +
                'Upgrade to Signature Agent'}
            </span>
          </>
        )}
      </MDBBtn>
    )
  }

  const renderNonSigAgent = () => {
    if (
      subSource &&
      subSource?.merchant !== 'stripe' &&
      !subSource?.canceled_at
    )
      return renderDowngradeBtn()

    if (!subscriptionId) {
      // 1. there is no active subscription.
      // 2. there is a valid payment method.
      // 3. if payment methods are valid, enable upgrade option.
      if (paymentMethods && paymentMethods.length) return renderUpgradeBtn()
    } else {
      return renderDowngradeBtn()
    }
  }

  const renderUpdateDowngradeBtn = () => {
    if (
      subSource &&
      subSource?.merchant !== 'stripe' &&
      !subSource?.canceled_at
    )
      return renderDowngradeBtn()

    // UPGRADE ------------------------------------------------
    // Affiliates & Associates ONLY.
    if (isNonSigAgent) return renderNonSigAgent()
    // DOWNGRADE ----------------------------------------------
    // Sig Agent Variants ONLY.
    else if (isSigAgentVarient) {
      // Permit the downgrade button for all Sig Agents, regardless of whether or not
      // we show an active subscription on file.  The downgrade notification will
      // go to BST where they can confirm/reconcile.

      // if (this.state.subscriptionId || (this.state.subSource && this.state.subSource?.merchant !== 'stripe' && !this.state.subSource?.canceled_at)) {
      // The Downgrade block below was listed inside this if block.
      // }

      // Deny Upline managers the ability to downgrade their agents.
      // Agents must downgrade themselves.
      if (
        UserProfileService.isAssumed() &&
        !UserProfileService.isA(
          ['agency-owner', 'system-admin', 'internal-admin'],
          true
        )
      )
        return <></>

      // Downgrade button.
      // Downgrade to Affiliate Agent
      return renderDowngradeBtn()
    } else if (UserProfileService.isA(['agent'])) {
      // contact BST to downgrade your subscriptions.
      return (
        <MDBAlert className="text-center" color="secondary">
          You have a <strong>leadership</strong> usertype.
          <br />
          Please contact Broker Support for further assistance.
        </MDBAlert>
      )
    } else {
      // contact BST to downgrade your subscriptions.
      return (
        <MDBAlert className="text-center" color="secondary">
          You have an <strong>advanced</strong> usertype.
          <br />
          Please contact Broker Support for further assistance.
        </MDBAlert>
      )
    }
  }

  return (
    <>
      <MDBCard id="SubscriptionPackageComponent">
        <MDBCardHeader>Account Subscription</MDBCardHeader>
        <MDBCardBody>
          <h6>Subscription:</h6>
          <SubscriptionStatus />
          <MDBCollapse isOpen={confirmUpgradeAccount}>
            <div className={'invoice ' + (isOnGrace ? ' on-grace' : '')}>
              <AgentTermAcceptance canAccept={false} />

              <table>
                <tbody>
                  <tr>
                    <td />
                    <td />
                    <td />
                  </tr>
                  <tr>
                    <td>Signature Agent Fee</td>
                    <td />
                    <td>${SIG_AGENT_RECURRING.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td>Onboarding & Account Setup</td>
                    <td>WAIVED</td>
                    <td>${SIG_AGENT_ONE_TIME.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td />
                    <td />
                    <td />
                  </tr>
                  <tr>
                    <td>
                      <span onClick={() => setConfirmUpgradeAccount(true)}>
                        Cancel Upgrade
                      </span>
                    </td>
                    <td>Total:</td>
                    <td>
                      $
                      {(
                        parseFloat(SIG_AGENT_RECURRING) +
                        (isOnGrace ? 0 : parseFloat(SIG_AGENT_ONE_TIME))
                      ).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </MDBCollapse>
          {renderUpdateDowngradeBtn()}
          <PromoCodeSubmitter />
        </MDBCardBody>
        <MDBCardFooter>
          <DowngradeModal
            downgrade={async (formData) => {
              if (!formData?.why_downgrade)
                return toast.error(
                  'Please complete: "Why are you downgrading today?"',
                  { position: toast.POSITION.TOP_RIGHT }
                )
              if (!formData?.what_better)
                return toast.error(
                  'Please complete: "What could USABG do better?"',
                  { position: toast.POSITION.TOP_RIGHT }
                )

              setShowDowngradeModal(false)

              const msg = await unsubscribeSigAgent(formData)
              if (msg)
                toast.success(`${msg}`, { position: toast.POSITION.TOP_RIGHT })
            }}
            toggle={() => setShowDowngradeModal(!showDowngradeModal)}
            pageName={downgradeContent?.page_name}
            content={downgradeContent?.content}
            showDowngradeModal={showDowngradeModal}
          />
        </MDBCardFooter>
      </MDBCard>
      <StripeDetails />
      <MDBRow>
        <MDBCol size="12" md="6" className="mt-1">
          <SyncSubscription
            onSync={(res) => {
              if (res?.status && res?.msg)
                toast.success(res.msg, { position: toast.POSITION.TOP_RIGHT })
              else if (res?.msg)
                toast.error(res.msg, { position: toast.POSITION.TOP_RIGHT })
            }}
            subscriptionId={subscriptionId}
          />
        </MDBCol>
      </MDBRow>
    </>
  )
}

export default observer(SubscriptionPackage)
